import React from 'react';
import { Fragment } from 'react';
import {
  Table as MuiTable,
  TableContainer,
  TableHead,
  TableBody,
  TableRow as Row,
  Typography,
  useTheme,
} from '@mui/material';
import TableRow from './TableRow';
import { CenteredFlexBox } from '../FlexBox';

export default function Table({
  id,
  tableTitle,
  columns,
  data,
  hover,
  selected,
  slotStyles,
  spacing,
}) {
  const theme = useTheme();

  return (
    <TableContainer
      className="scrollable-container"
      sx={{
        height: '100%',
        ...(slotStyles?.container ?? {}),
      }}
    >
      {tableTitle ? (
        <CenteredFlexBox
          border={`1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`}
          style={{
            backgroundColor:
              theme === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
          }}
        >
          <Typography variant="subtitle1" color="primary" sx={{
            fontWeight: 600
          }}>
            {tableTitle}
          </Typography>
        </CenteredFlexBox>
      ) : null}
      <MuiTable
        id={id}
        aria-label="table"
        stickyHeader
        sx={{ ...(slotStyles?.table ?? {}) }}
      >
        <TableHead sx={{ ...(slotStyles?.head ?? {}) }}>
          <TableRow columns={columns} rowVariant="head" />
        </TableHead>
        <TableBody sx={{ ...(slotStyles?.body ?? {}) }}>
          {data.map((d, index) => {
            const rowKey = d?.Id ?? d?.id ?? `fallback-row-${index}`;
            return (
              <Fragment key={rowKey}>
                {
                  spacing && <Row style={{ height: spacing }} /> //Do not remove it
                }
                <TableRow
                  hover={hover}
                  selectedStyle={slotStyles?.selected}
                  selected={selected != null && selected === (d?.Id ?? d?.id)}
                  columns={columns.map((col) => ({
                    ...col,
                    label: d[col.id],
                  }))}
                  rowData={d}
                />
                {spacing && index === data.length - 1 && (
                  <Row style={{ height: spacing }} />
                )}
              </Fragment>
            );
          })}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}
